import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { pricingActions } from '../../store/modules/pricing';

const useChangePeriodHandler = () => {
  const dispatch = useDispatch();
  const handleChangePeriod = useCallback(
    (periodView: SubscriptionPeriod) =>
      dispatch(pricingActions.changePlanPeriodView(periodView)),
    []
  );

  return handleChangePeriod;
};

export default useChangePeriodHandler;
